import React, { useState } from 'react';
import tw from 'twin.macro';
import styled from 'styled-components';

const BurgerButtonContainer = styled.button`
  ${tw`
    inline-block cursor-pointer z-10
  `}
  min-height: 30px;
  -webkit-tap-highlight-color: transparent;
  &:focus:not(.focus-visible) {
    outline: none;
  }
  div {
    width: 39px;
    height: 1px;
    border-bottom: 1px solid ${(p) => p.theme.color.white};
    margin: ${(p) => (p.collapsed ? 0 : '8px 0')};  
    transition: 0.4s;
  }
`;

const BurgerButton = ({ handleClick }) => {
  const [collapsed, toggleMenu] = useState(false);
  const menuHandler = () => {
    toggleMenu(!collapsed);
    handleClick();
  };
  return (
    <BurgerButtonContainer
      collapsed={collapsed}
      onClick={() => menuHandler()}
      role="button"
      aria-controls="header-menu"
      data-a11y="false"
      aria-label={collapsed ? 'Hide menu' : 'Show menu'}
    >
      <div />
      <div />
    </BurgerButtonContainer>
  );
};

export default BurgerButton;
